import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { CancelSaleModalComponent } from './cancel-sale-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CancelSaleModalService {
  constructor(private dialog: MatDialog) {}

  open(config: MatDialogConfig<any> = new MatDialogConfig()) {
    const dialogRef = this.dialog.open(CancelSaleModalComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        //this.refreshListSource.next(res);
      })
    );
  }
}
